import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from './DateJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function GMTDate$Companion$$childSerializers$_anonymous__gyfycy() {
  return createSimpleEnumSerializer('io.ktor.util.date.WeekDay', values());
}
function GMTDate$Companion$$childSerializers$_anonymous__gyfycy_0() {
  return createSimpleEnumSerializer('io.ktor.util.date.Month', values_0());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, GMTDate$Companion$$childSerializers$_anonymous__gyfycy);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, tmp_1, null, null, lazy(tmp_2, GMTDate$Companion$$childSerializers$_anonymous__gyfycy_0), null, null];
        this.START_1 = GMTDate(0n);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('io.ktor.util.date.GMTDate', this, 9);
        tmp0_serialDesc.addElement_5pzumi_k$('seconds', false);
        tmp0_serialDesc.addElement_5pzumi_k$('minutes', false);
        tmp0_serialDesc.addElement_5pzumi_k$('hours', false);
        tmp0_serialDesc.addElement_5pzumi_k$('dayOfWeek', false);
        tmp0_serialDesc.addElement_5pzumi_k$('dayOfMonth', false);
        tmp0_serialDesc.addElement_5pzumi_k$('dayOfYear', false);
        tmp0_serialDesc.addElement_5pzumi_k$('month', false);
        tmp0_serialDesc.addElement_5pzumi_k$('year', false);
        tmp0_serialDesc.addElement_5pzumi_k$('timestamp', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gyl192_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance().$childSerializers_1;
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.seconds_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.minutes_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.hours_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.dayOfWeek_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 4, value.dayOfMonth_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 5, value.dayOfYear_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.month_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 7, value.year_1);
        tmp1_output.encodeLongElement_ovnxxh_k$(tmp0_desc, 8, value.timestamp_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gyl192_k$(encoder, value instanceof GMTDate_0() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = 0;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_local4 = 0;
        var tmp9_local5 = 0;
        var tmp10_local6 = null;
        var tmp11_local7 = 0;
        var tmp12_local8 = 0n;
        var tmp13_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp14_cached = Companion_getInstance().$childSerializers_1;
        if (tmp13_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp14_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.decodeLongElement_994anb_k$(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp14_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp14_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.decodeIntElement_941u6a_k$(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.decodeLongElement_994anb_k$(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp13_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GMTDate_0().new_io_ktor_util_date_GMTDate_1rd0je_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[3].get_value_j01efc_k$(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[6].get_value_j01efc_k$(), IntSerializer_getInstance(), LongSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var GMTDateClass;
function GMTDate_0() {
  if (GMTDateClass === VOID) {
    class $ {
      constructor(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
        Companion_getInstance();
        this.seconds_1 = seconds;
        this.minutes_1 = minutes;
        this.hours_1 = hours;
        this.dayOfWeek_1 = dayOfWeek;
        this.dayOfMonth_1 = dayOfMonth;
        this.dayOfYear_1 = dayOfYear;
        this.month_1 = month;
        this.year_1 = year;
        this.timestamp_1 = timestamp;
      }
      compareTo_nbh2nh_k$(other) {
        return compareTo(this.timestamp_1, other.timestamp_1);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_nbh2nh_k$(other instanceof GMTDate_0() ? other : THROW_CCE());
      }
      toString() {
        return 'GMTDate(seconds=' + this.seconds_1 + ', minutes=' + this.minutes_1 + ', hours=' + this.hours_1 + ', dayOfWeek=' + this.dayOfWeek_1.toString() + ', dayOfMonth=' + this.dayOfMonth_1 + ', dayOfYear=' + this.dayOfYear_1 + ', month=' + this.month_1.toString() + ', year=' + this.year_1 + ', timestamp=' + this.timestamp_1.toString() + ')';
      }
      hashCode() {
        var result = this.seconds_1;
        result = imul(result, 31) + this.minutes_1 | 0;
        result = imul(result, 31) + this.hours_1 | 0;
        result = imul(result, 31) + this.dayOfWeek_1.hashCode() | 0;
        result = imul(result, 31) + this.dayOfMonth_1 | 0;
        result = imul(result, 31) + this.dayOfYear_1 | 0;
        result = imul(result, 31) + this.month_1.hashCode() | 0;
        result = imul(result, 31) + this.year_1 | 0;
        result = imul(result, 31) + getBigIntHashCode(this.timestamp_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GMTDate_0()))
          return false;
        if (!(this.seconds_1 === other.seconds_1))
          return false;
        if (!(this.minutes_1 === other.minutes_1))
          return false;
        if (!(this.hours_1 === other.hours_1))
          return false;
        if (!this.dayOfWeek_1.equals(other.dayOfWeek_1))
          return false;
        if (!(this.dayOfMonth_1 === other.dayOfMonth_1))
          return false;
        if (!(this.dayOfYear_1 === other.dayOfYear_1))
          return false;
        if (!this.month_1.equals(other.month_1))
          return false;
        if (!(this.year_1 === other.year_1))
          return false;
        if (!(this.timestamp_1 === other.timestamp_1))
          return false;
        return true;
      }
      static new_io_ktor_util_date_GMTDate_1rd0je_k$(seen0, seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(511 === (511 & seen0))) {
          throwMissingFieldException(seen0, 511, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.seconds_1 = seconds;
        $this.minutes_1 = minutes;
        $this.hours_1 = hours;
        $this.dayOfWeek_1 = dayOfWeek;
        $this.dayOfMonth_1 = dayOfMonth;
        $this.dayOfYear_1 = dayOfYear;
        $this.month_1 = month;
        $this.year_1 = year;
        $this.timestamp_1 = timestamp;
        return $this;
      }
    }
    initMetadataForClass($, 'GMTDate', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance});
    GMTDateClass = $;
  }
  return GMTDateClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  WeekDay_MONDAY_instance = new (WeekDay())('MONDAY', 0, 'Mon');
  WeekDay_TUESDAY_instance = new (WeekDay())('TUESDAY', 1, 'Tue');
  WeekDay_WEDNESDAY_instance = new (WeekDay())('WEDNESDAY', 2, 'Wed');
  WeekDay_THURSDAY_instance = new (WeekDay())('THURSDAY', 3, 'Thu');
  WeekDay_FRIDAY_instance = new (WeekDay())('FRIDAY', 4, 'Fri');
  WeekDay_SATURDAY_instance = new (WeekDay())('SATURDAY', 5, 'Sat');
  WeekDay_SUNDAY_instance = new (WeekDay())('SUNDAY', 6, 'Sun');
  if (Companion_instance_1 === VOID) {
    Companion_instance;
    new (Companion_0())();
  }
}
var WeekDay_MONDAY_instance;
var WeekDay_TUESDAY_instance;
var WeekDay_WEDNESDAY_instance;
var WeekDay_THURSDAY_instance;
var WeekDay_FRIDAY_instance;
var WeekDay_SATURDAY_instance;
var WeekDay_SUNDAY_instance;
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      from_1ixx1u_k$(ordinal) {
        return get_entries().get_c1px32_k$(ordinal);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
function values() {
  static_init();
  return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var WeekDayClass;
function WeekDay() {
  if (WeekDayClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, value) {
        super(name, ordinal);
        this.value_1 = value;
      }
    }
    initMetadataForClass($, 'WeekDay');
    WeekDayClass = $;
  }
  return WeekDayClass;
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  Month_JANUARY_instance = new (Month())('JANUARY', 0, 'Jan');
  Month_FEBRUARY_instance = new (Month())('FEBRUARY', 1, 'Feb');
  Month_MARCH_instance = new (Month())('MARCH', 2, 'Mar');
  Month_APRIL_instance = new (Month())('APRIL', 3, 'Apr');
  Month_MAY_instance = new (Month())('MAY', 4, 'May');
  Month_JUNE_instance = new (Month())('JUNE', 5, 'Jun');
  Month_JULY_instance = new (Month())('JULY', 6, 'Jul');
  Month_AUGUST_instance = new (Month())('AUGUST', 7, 'Aug');
  Month_SEPTEMBER_instance = new (Month())('SEPTEMBER', 8, 'Sep');
  Month_OCTOBER_instance = new (Month())('OCTOBER', 9, 'Oct');
  Month_NOVEMBER_instance = new (Month())('NOVEMBER', 10, 'Nov');
  Month_DECEMBER_instance = new (Month())('DECEMBER', 11, 'Dec');
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion_1())();
  }
}
var Month_JANUARY_instance;
var Month_FEBRUARY_instance;
var Month_MARCH_instance;
var Month_APRIL_instance;
var Month_MAY_instance;
var Month_JUNE_instance;
var Month_JULY_instance;
var Month_AUGUST_instance;
var Month_SEPTEMBER_instance;
var Month_OCTOBER_instance;
var Month_NOVEMBER_instance;
var Month_DECEMBER_instance;
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      from_1ixx1u_k$(ordinal) {
        return get_entries_0().get_c1px32_k$(ordinal);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
function values_0() {
  static_init_0();
  return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
}
function get_entries_0() {
  static_init_0();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var $ENTRIES_0;
var MonthClass;
function Month() {
  if (MonthClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, value) {
        super(name, ordinal);
        this.value_1 = value;
      }
    }
    initMetadataForClass($, 'Month');
    MonthClass = $;
  }
  return MonthClass;
}
function WeekDay_MONDAY_getInstance() {
  static_init();
  return WeekDay_MONDAY_instance;
}
function WeekDay_TUESDAY_getInstance() {
  static_init();
  return WeekDay_TUESDAY_instance;
}
function WeekDay_WEDNESDAY_getInstance() {
  static_init();
  return WeekDay_WEDNESDAY_instance;
}
function WeekDay_THURSDAY_getInstance() {
  static_init();
  return WeekDay_THURSDAY_instance;
}
function WeekDay_FRIDAY_getInstance() {
  static_init();
  return WeekDay_FRIDAY_instance;
}
function WeekDay_SATURDAY_getInstance() {
  static_init();
  return WeekDay_SATURDAY_instance;
}
function WeekDay_SUNDAY_getInstance() {
  static_init();
  return WeekDay_SUNDAY_instance;
}
function Month_JANUARY_getInstance() {
  static_init_0();
  return Month_JANUARY_instance;
}
function Month_FEBRUARY_getInstance() {
  static_init_0();
  return Month_FEBRUARY_instance;
}
function Month_MARCH_getInstance() {
  static_init_0();
  return Month_MARCH_instance;
}
function Month_APRIL_getInstance() {
  static_init_0();
  return Month_APRIL_instance;
}
function Month_MAY_getInstance() {
  static_init_0();
  return Month_MAY_instance;
}
function Month_JUNE_getInstance() {
  static_init_0();
  return Month_JUNE_instance;
}
function Month_JULY_getInstance() {
  static_init_0();
  return Month_JULY_instance;
}
function Month_AUGUST_getInstance() {
  static_init_0();
  return Month_AUGUST_instance;
}
function Month_SEPTEMBER_getInstance() {
  static_init_0();
  return Month_SEPTEMBER_instance;
}
function Month_OCTOBER_getInstance() {
  static_init_0();
  return Month_OCTOBER_instance;
}
function Month_NOVEMBER_getInstance() {
  static_init_0();
  return Month_NOVEMBER_instance;
}
function Month_DECEMBER_getInstance() {
  static_init_0();
  return Month_DECEMBER_instance;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_instance_2 as Companion_instance28c8ewrsbf6jf,
  Companion_instance_1 as Companion_instance1b54ec2xzvaat,
  GMTDate_0 as GMTDate2jy5n6whlljcu,
};
//endregion

//# sourceMappingURL=Date.mjs.map
